import { Base } from "ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

export interface IAppReportPageData {
    canCreateAppReports: boolean;
    canEditAllModuleProperties: boolean;
    units: IIdTitleNode[];
}

export class AppReportPageData implements IAppReportPageData {
    canCreateAppReports: boolean;
    canEditAllModuleProperties: boolean;
    units: IdTitleNode[];

    constructor();
    constructor(obj: IAppReportPageData);
    constructor(obj?: any) {
        this.canCreateAppReports = obj && obj.canCreateAppReports || false;
        this.canEditAllModuleProperties = obj && obj.canEditAllModuleProperties || false;
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
    }
}
